import React from 'react';
import styled from 'styled-components';
import { system, extractSysProps } from './system';

// System prop keys consumed by Text (not forwarded to DOM).
// Intentionally narrower than the full SYS_KEYS_SET — molekule's Text
// composed fewer utilities than Box.
const TEXT_SYS_KEYS: ReadonlySet<string> = new Set([
  'm',
  'mt',
  'mb',
  'ml',
  'mr',
  'mx',
  'my',
  'p',
  'pt',
  'pb',
  'pl',
  'pr',
  'px',
  'py',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'textAlign',
  'color',
  'backgroundColor',
  'bg',
  'width',
  'height',
  'maxWidth',
  'minWidth',
  'display',
  'flex',
  'alignSelf',
  'border',
  'borderRadius',
  'borderColor',
  'position',
  'top',
  'right',
  'bottom',
  'left',
  'overflow',
  'cursor',
  'opacity',
]);

interface StyledInnerProps {
  $sys?: Record<string, any>;
  as?: any;
}

const StyledText = styled.span<StyledInnerProps>`
  ${(p) => system(p.$sys, p.theme)}
`;

export interface TextProps extends Omit<React.HTMLAttributes<HTMLElement>, 'color'> {
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  children?: React.ReactNode;
  id?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

const Text = React.forwardRef<HTMLElement, TextProps>(
  function Text(props, ref) {
    const { sys, rest } = extractSysProps(props as Record<string, any>, TEXT_SYS_KEYS);
    return <StyledText ref={ref as any} $sys={sys} {...rest} />;
  },
);

export default Text;
